import React from 'react';
import * as Yup from 'yup';

import { FeeType, NewFeeRequest } from '@ndvr/billing-api';

import { FormSheet } from '@/components/FormSheet';
import { useRequiredParams } from 'utils';
import { useCreateNewFee } from 'views/billing/billing-queries';
import { PortfolioSelect } from 'views/billing/widgets/PortfolioSelect';
import { FormMoneyInput, FormSection, FormSelect, requiredStringValidator } from 'widgets';

const newFeeFormSchema = Yup.object().shape({
    settlementPortfolioGUID: requiredStringValidator,
    feeType: requiredStringValidator,
    feeAmount: requiredStringValidator,
});
export const NewFeeDrawer = ({ onClose }: { onClose: () => void }) => {
    const { globalAccountGUID } = useRequiredParams(['globalAccountGUID']);
    const { mutate, isPending } = useCreateNewFee(globalAccountGUID);

    return (
        <FormSheet
            title="Create New Fee Entry"
            onClose={onClose}
            formSchema={newFeeFormSchema}
            pending={isPending}
            submitLabel="Create"
            onSubmit={(data: NewFeeRequest, close) => mutate(data, { onSuccess: close })}
        >
            <FormSection>
                <PortfolioSelect name="settlementPortfolioGUID" globalAccountGUID={globalAccountGUID} />
                <FormSelect vertical name="feeType" label="Fee type">
                    <option></option>
                    <option value={FeeType.AUM}>AUM</option>
                    <option value={FeeType.MANAGEMENT}>Management</option>
                </FormSelect>
                <FormMoneyInput vertical name="feeAmount" label="Fee amount" decimalScale={2} />
            </FormSection>
        </FormSheet>
    );
};
